<template>
  <div class="mobile-container">
    <IONotifications/>
    <div class="top_menu">
      <div class="card">
        <div class="card-body flex justify-content-end">
          <button @click="mixinGoToRouter('TabletMyOrders')" class="btn btn-default">Заявки</button>
          <button @click="mixinGoToRouter('TabletMap')" class="btn btn-default">Карта</button>
          <button @click="mixinGoToRouter('TabletRequests')" class="btn btn-default">Уведомления <span
            class="hidden badge badge-info">10</span></button>
          <button @click="mixinGoToRouter('TabletReport')" class="btn btn-default">Отчет</button>
        </div>
      </div>
    </div>
    <div class="content-container">
<!--      <transition>-->
        <router-view/>
<!--      </transition>-->
    </div>
  </div>
</template>
<script type="text/babel">

import IONotifications from "@/components/notifications/IONotifications";

export default {
  components: {IONotifications},
  computed: {},
  watch: {},
  mounted() {
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.main-content {
  padding: 5px !important;
}
</style>
<style>
body {
  background-color: #dedede;
}
</style>
<style scoped>
.card {
  margin-bottom: 0px;
}

.content-container {
  height: calc(100vh - 56px);
  overflow: auto;
}

.mobile-container {
  height: 100vh;
}

.card-body .btn {
  margin-left: 5px;
}

.card-body {
  padding: 10px !important;
}

</style>
